export default __webpack_public_path__ + "static/media/lecture-icon.0abb3f39.png";